/**
 * @prettier
 */

/* eslint-disable no-unused-vars */
import { datadogRum } from '@datadog/browser-rum';

// Services
import logService from './logService';
import ApiService from '../api/api';
import { areCookiesEnabled, isInIframe } from './helpers';
import selectStorage from './selectStorage';

// Config
import {
    ERRORS_TO_DOWNGRADE,
    ERRORS_TO_DISREGARD,
} from '../../config/thirdPartyErrors';

/**
 * Initialises DataDog
 *
 */
function initialise() {
    if (process.env.REACT_APP_DATADOG_ENABLED === 'true') {
        ApiService.getDataDogCredentials().then(response => {
            if (response.data) {
                datadogRum.init({
                    applicationId: response.data.app_id,
                    clientToken: response.data.token,
                    site: process.env.REACT_APP_DATADOG_SITE,
                    service: process.env.REACT_APP_DATADOG_SERVICE,
                    version: '1.0.0',
                    env: process.env.REACT_APP_ENV,
                    sessionSampleRate: 100,
                    sessionReplaySampleRate: 0,
                    trackUserInteractions: true,
                    trackResources: true,
                    trackLongTasks: true,
                    defaultPrivacyLevel: 'mask',
                    useCrossSiteSessionCookie: isInIframe(),
                    beforeSend: event => {
                        if (shouldDiscard(event)) {
                            return false;
                        }
                    },
                });
                setUserContext();
                logService.log('DataDog initialised.');
            } else {
                logService.error('Could not initalise DataDog.');
            }
        });
    }
}

// Filter out noisy console logs if they match message and url specified
function shouldDiscard(event) {
    if (event.type === 'error') {
        const item = ERRORS_TO_DISREGARD.find(
            ({ message }) => message === event.error.message
        );

        if (item) {
            for (let i = 0; i < item.url.length; i++) {
                if (event.view.referrer.includes(item.url[i])) {
                    return true;
                }
            }
        }
    }
    return false;
}

function getLogBody() {
    return {
        uuid: selectStorage(areCookiesEnabled()).getItem('uuid'),
        submission_id:
            selectStorage(areCookiesEnabled()).getItem('submissionid'),
        integration: isInIframe() ? 'embedded' : 'standalone',
    };
}

function setUserContext() {
    if (process.env.REACT_APP_DATADOG_ENABLED !== 'true') {
        return;
    }

    const uuid = selectStorage(areCookiesEnabled()).getItem('uuid');
    if (!uuid) {
        return;
    }

    const user = {
        id: uuid,
        UUID: uuid,
    };

    const submissionId = selectStorage(areCookiesEnabled()).getItem(
        'submissionid'
    );
    if (submissionId) {
        user['Submission Id'] = submissionId;
    }

    datadogRum.setUser(user);
}

function log(message, extraParams = {}) {
    datadogRum.addAction(message, { ...getLogBody(), ...extraParams });
}

function createError(message) {
    this.error(new Error(message));
}

function error(error, extraParams = {}) {
    // If the error provided is a third party error that we don't want logged as an error,
    // Log it instead
    if (ERRORS_TO_DOWNGRADE.includes(error.message)) {
        this.log(error.message);
    } else {
        datadogRum.addError(error, { ...getLogBody(), ...extraParams });
    }
}

const DataDogService = {
    initialise,
    setUserContext,
    log,
    error,
    createError,
};

export default DataDogService;
